import { render, staticRenderFns } from "./dialogDelete.vue?vue&type=template&id=6cff56dd&scoped=true&"
import script from "./dialogDelete.vue?vue&type=script&lang=js&"
export * from "./dialogDelete.vue?vue&type=script&lang=js&"
import style0 from "./dialogDelete.vue?vue&type=style&index=0&id=6cff56dd&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cff56dd",
  null
  
)

export default component.exports